<template>
    <div class="m-form__section m-form__section--third">
        <div class="form-group m-form__group row">
            <label class="col-lg-3 col-form-label">{{ labels['lastname'] }} * :</label>
            <div class="col-lg-6">
                <input type="text" class="form-control m-input" :class="validClass('last_name')" v-model="form.last_name" @keyup="inputListener('last_name')">
                <div class="invalid-feedback">{{ errors['last_name'] }}</div>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-lg-3 col-form-label">{{ labels['firstname'] }} * :</label>
            <div class="col-lg-6">
                <input type="text" class="form-control m-input" :class="validClass('first_name')" v-model="form.first_name" @keyup="inputListener('first_name')">
                <div class="invalid-feedback">{{ errors['first_name'] }}</div>
            </div>
        </div>
        <div class="form-group m-form__group row" v-show="!user">
            <label class="col-lg-3 col-form-label">{{ labels['email'] }} * :</label>
            <div class="col-lg-6">
                <input type="text" class="form-control m-input" :class="validClass('email')" v-model="form.email" @keyup="inputListener('email')">
                <div class="invalid-feedback">{{ errors['email'] }}</div>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-lg-3 col-form-label">{{ labels['password'] }} * :</label>
            <div class="col-lg-6">
                <input type="password" class="form-control m-input" :class="validClass('password')" v-model="form.password" @keyup="inputListener('password')">
                <div class="invalid-feedback">{{ errors['password'] }}</div>
                <span class="form-text text-muted" v-if="!errors.password">{{ labels.password_help_text }}</span>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12">{{ labels['user_roles'] }} * :</label>
            <div class="col-lg-4 col-md-9 col-sm-12 form-group-sub">
                <select :class="'user-role-choices-'+index" class="form-control" :value="form.roles[0]" @change="inputListener('roles')">
                    <option value="" disabled selected>{{ labels['select_an_option'] }}</option>
                    <option value="ROLE_MARKETING">ROLE_MARKETING</option>
                    <option value="ROLE_MARKETING_PLUS">ROLE_MARKETING_PLUS</option>
                    <option value="ROLE_ADMIN">ROLE_ADMIN</option>
                    <option value="ROLE_ADMIN_PLUS">ROLE_ADMIN_PLUS</option>
                    <option value="ROLE_RESEARCH">ROLE_RESEARCH</option>
                </select>
                <div class="invalid-feedback-custom">{{ errors['roles'] }}</div>
            </div>
        </div>
        <div class="m-form__actions m-form__actions">
            <div class="row">
                <div class="col-lg-7">{{ labels['required_fields_info'] }}</div>
                <div class="col-lg-1">
                    <button type="button" class="btn btn-secondary" @click="setIndex({name: 'editIndex', value: null})">{{ labels.cancel }}</button>
                </div>
                <div class="col-lg-1">
                    <button type="button" class="btn btn-primary" @click="submitForm">{{ submitLabel }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const timer = 3000

// Dependencies
import { mapState, mapActions } from 'vuex'
import { HTTP } from '../../assets/js/axiosConfig'
import Choices from 'choices.js'
// Mixins
import Uuid from '../../assets/js/mixins'
import SweetAlert from '../../assets/js/mixins'

export default {
    props: ['user', 'index'],
    mixins: [Uuid, SweetAlert],
    data () {
        return {
            form: {
                user_id: '',
                first_name: '',
                last_name: '',
                email: '',
                roles: [],
                password: ''
            },
            errors: {
                user_id: '',
                first_name: '',
                last_name: '',
                email: '',
                roles: '',
                password: ''
            },
            required: ['first_name', 'last_name', 'email', 'roles', 'password']
        }
    },
    computed: {
        ...mapState({
            labels: store => store.labels
        }),
        submitLabel () {
            return this.user ? this.labels['update_user'] : this.labels['add_user_button']
        }
    },
    methods: {
        ...mapActions('users', [
            'setIndex',
            'updateUserList',
            'getUsers'
        ]),
        submitForm () {
            if (this.validateForm()) {
                if (this.user) {
                    this.updateUser()
                } else {
                    this.createUser()
                }
            }
        },
        updateUser () {
            HTTP.put(`api/users/${this.user.user_id}`, this.form)
                .then(() => {
                    // Get updated list
                    this.getUsers()
                    // Alert on success
                    this.sweetAlert('success', this.labels.user_updated, timer)
                    // Close form
                    this.setIndex({ name: 'editIndex', value: null })
                })
                .catch(err => {
                    console.log(err)
                    this.sweetAlert('error', this.labels.error_updating_user, timer)
                })
        },
        createUser () {
            this.form.user_id = this.uuid()
            HTTP.post(`api/users`, this.form)
                .then(() => {
                    // Alert on success
                    this.sweetAlert('success', this.labels.user_created, timer)
                    // Update list data
                    this.updateUserList({ action: 'POST', data: this.form })
                    // Close form
                    this.setIndex({ name: 'editIndex', value: null })
                })
                .catch(err => {
                    console.log(err)
                    this.sweetAlert('error', this.labels.error_creating_user, timer)
                })
        },
        cloneData (originalData, form) {
            var key
            for (key in form) {
                if (originalData.hasOwnProperty(key)) {
                    form[key] = originalData[key]
                } else {
                    form[key] = ''
                }
            }
        },
        validateEmailFormat (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validatePasswordFormat (password) {
            // Minimum 8 characters, 1 number , 1 Uppercase
            var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,10}/g;
            return re.test(String(password))
        },
        validateForm () {
            var validInputs = this.required.filter((field) => {
                if (!this.form[field].length) {
                    if (field === 'roles') {
                        $('.choices__inner').addClass('choices-warning')
                    }
                    this.errors[field] = this.labels.empty_value_warning
                } else if (field === 'email' && !this.validateEmailFormat(this.form.email)) {
                    this.errors[field] = this.labels.valid_email_warning
                } else if (field === 'password' && !this.validatePasswordFormat(this.form.password)) {
                    this.errors[field] = this.labels.password_help_text
                } else {
                    return field
                }
            })
            this.$forceUpdate()
            return validInputs.length === this.required.length
        },
        inputListener (field) {
            if (field === 'email' && !this.validateEmailFormat(this.form.email)) {
                this.errors[field] = this.labels.valid_email_warning
            } else if (field === 'password' && !this.validatePasswordFormat(this.form.password)) {
                this.errors[field] = this.labels.password_help_text
            } else {
                if (field === 'roles') {
                    this.form.roles = [event.detail.value]
                    $('.choices__inner').removeClass('choices-warning')
                }
                this.errors[field] = ''
            }
            // this.validClass(field)
            this.$forceUpdate()
        },
        validClass (input) {
            if (this.errors[input]) {
                return 'is-invalid'
            } else if (this.form[input].length) {
                return 'is-valid'
            } else {
                return ''
            }
        }
    },
    mounted () {
        var my = this
        var choiceRoles = new Choices('.user-role-choices-' + my.index)
    },
    created () {
        if (this.user) {
            this.cloneData(this.user, this.form)
        }
    }
}
</script>

<style>
    .invalid-feedback-custom {
        width: 100%;
        margin-top: -1.65rem;
        font-size: 80%;
        color: #fe5f55;
    }

    .choices-warning {
        border-color: #fe5f55;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/UserForm.vue